import { StaticBaseDao } from '@/dao/StaticBaseDao';
import { ServerTime } from '@/objects/generated';

export class SystemDao extends StaticBaseDao {
    /**
     * Return the server time object from the server.
     * @returns
     */
    public static async GetServerTime(): Promise<ServerTime | null> {
        return this.BaseFetch(ServerTime, '../systemapi/systemnotifier/ping');
    }
}
